import { useCallback } from "react";
import { Link } from "react-router-dom";

import { badgeVariants } from "@/components/ui/badge";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { cn } from "@/lib/utils";
import {
  CanManageTags,
  PublicRecording,
  RoleGroupEnum,
} from "@classview/shared-types";

import { RemoveTagFromRecording } from "./remove-tag-from-recording";

type TagListProps = {
  recording: PublicRecording;
};

export function TagList({ recording }: TagListProps) {
  const { hasPermission, organisation } = useOrganisation();
  const generateTagLink = useCallback((tagId: string) => {
    return `/recordings/all?tags=${tagId}`;
  }, []);
  const isOwner = recording.organisation.id === organisation.id;

  const canManageTags =
    hasPermission(CanManageTags) &&
    (organisation.roleGroup === RoleGroupEnum.ADMIN ||
      organisation.roleGroup === RoleGroupEnum.USER) &&
    isOwner;

  return (
    <div className="inline-flex flex-wrap gap-2 md:w-max">
      {recording.tags.map((tag) => (
        <span key={tag.id} className="md:flex md:h-9">
          <Link
            to={generateTagLink(tag.id)}
            className={cn(
              badgeVariants({ variant: "outline" }),
              "shrink-0 md:place-self-center",
            )}
          >
            {tag.name}
            {canManageTags && (
              <RemoveTagFromRecording
                recordingId={recording.id}
                tagId={tag.id}
              />
            )}
          </Link>
        </span>
      ))}
    </div>
  );
}
